// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"c77d7199","365":"af0a0137","372":"0e6b9e82","787":"7157d651","933":"f5c04282","964":"6dbd9f4f"}[chunkId] + ".chunk.js";
};